import request from './request.js';
import {requestbody} from './request.js'

export async function noticetemplate (params = {
}) {
return await requestbody('/noticeExTemplate/save', 'post', params)
}

export async function indexExpage(params = {

}) {
    return await requestbody('/indexEx/page', 'post', params)
}

export async function templatepage(params = {

}) {
    return await requestbody('/notice-template/page', 'get', params)
}

export async function noticeindexpage(params = {

}) {
    return await requestbody('/managementEx/page', 'post', params)
}
export async function userpage(params = {

}) {
    return await requestbody('/system/user/page', 'get', params)
}
export async function userGroupsave(params = {

}) {
    return await requestbody('/userGroup/save', 'post', params)
}

export async function grouppage(params = {

}) {
    return await requestbody('/group/page', 'get', params)
}

export async function saveIndex(params = {

}) {
    return await requestbody('/indexEx/save/Index', 'post', params)
}

export async function indexExgetOne(params = {

}) {
    return await request('/indexEx/getOne', 'post', params)
}
export async function groupdelete(params = {

}) {
    return await request('/group/delete', 'post', params)
}

export async function indexdelete(params = {

}) {
    return await requestbody('/indexEx/deleteBatch', 'post', params)
}


//风险监控
export async function managementExpage(params = {

}) {
    return await requestbody('/managementEx/page', 'post', params)
}
//查询本月累计历史记录
export async function showIndicatorValueHistory(params = {

}) {
    return await requestbody('/managementEx/showIndicatorValueHistory', 'post', params)
}
//风险监控-模型查询
export async function fxjk_mxcx(params = {

}) {
    return await requestbody('mappingEx/page', 'get', params)
}
//风险监控-映射规则编码查询
export async function fxjk_ysgzbmcx(params = {

}) {
    return await request('mappingEx/rule/page', 'post', params)
}
//风险监控-风险保存
export async function fxjk_save(params = {

}) {
    return await requestbody('managementEx/save', 'post', params)
}
//风险监控-单条查询
export async function fxjk_getPolicyInfo(params = {

}) {
    return await request('managementEx/getPolicyInfo', 'post', params)
}

//风险监控-税表名称查询
export async function fxjk_sbmccx(params = {

}) {
    return await requestbody('shuib-name-dict/page', 'get', params)
}
//风险监控-查看所有公司
export async function fxjk_comapny(params = {

}) {
    return await requestbody('sys/queryCompanyList', 'post', params)
}
//风险监控-删除
export async function fxjk_delete(params = {

}) {
    return await requestbody('managementEx/deletes', 'post', params)
}
//风险监控-风控计算
export async function fxjk_calculation(params = {

}) {
    return await requestbody('managementEx/calculation', 'post', params)
}

export async function policypage(params = {

}) {
    return await requestbody('/wiki/policy/page', 'post', params)
}

//通知组查询

export async function fetchGroupUser(params = {

}) {
    return await request('/userGroup/fetchGroupUser', 'post', params)
}
export async function queryCompanyShuibDict(params = {

}) {
    return await requestbody('sys/queryCompanyShuibDict', 'post', params)
}
//批量导出
export async function managementExExport(params = {

}) {
    return await requestbody('managementEx/export', 'post', params)
}
//重新计算
export async function calculationAgain(params = {

}) {
    return await requestbody('managementEx/calculationAgain', 'post', params)
}
//保存本期同期
export async function editIndexPeriod(params = {

}) {
    return await request('/managementEx/editIndexPeriod', 'post', params)
}
//保存本月累计
export async function indicatorValue(params = {

}) {
    return await request('/managementEx/indicatorValue', 'post', params)
}
//事件通知查询
export async function companyuserinfopage(params = {

}) {
    return await requestbody('/company-user-info/page', 'post', params)
}

//事件保存/更新
export async function companyuserinfosave(params = {

}) {
    return await requestbody('/company-user-info/save', 'post', params)
}
//删除
export async function companyuserinfodelete(params = {

}) {
    return await requestbody('/company-user-info/delete', 'post', params)
}
